import { DecimalPipe, I18nPluralPipe, JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { CartComponentStore, CartItemComponentStore } from 'cart-data';
import { ItemComponentBase, ProductComponentBase } from 'products-ui';

@Component({
  selector: 'ideal-cart-view-purchase-options',
  imports: [MatButtonModule, RouterModule, DecimalPipe, I18nPluralPipe],
  standalone: true,
  templateUrl: './cart-view-purchase-options.component.html',
  styleUrl: './cart-view-purchase-options.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CartItemComponentStore],
  host: {
    '[class.loading]': 'isLoading()',
    '[attr.layout]': 'layout()',
  },
})
export class CartViewPurchaseOptionsComponent extends ProductComponentBase {
  public readonly layout = input<'card' | 'row'>('card');

  private readonly _cartStore = inject(CartComponentStore);
  protected readonly isLoading = computed(() => this._cartStore.cartLoading());
  protected readonly cartItems = computed(() => this._cartStore.cartItems().filter((v) => this.productId()?.equals(v.id) ?? false));
  protected readonly cartItemCount = computed(() => this.cartItems().length);
  protected readonly optionsPluralMap: { [k: string]: string } = { '=1': 'option', other: 'options' };

  // private readonly _cartItemStore = inject(CartItemComponentStore);

  // protected readonly isPriceOnRequest = computed(
  //   () => this.pricing().pricingModel.isCallForPricing || !this.pricing().pricingModel.hasPrice,
  // );

  constructor() {
    super();
    // effect(() => {
    //   this._cartItemStore.selectByItemId(this.itemId());
    // });
  }
}
